class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.backdrop = document.getElementById("cart-notification-backdrop");
    this.header = document.querySelector("sticky-header");

    this.notification.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());

    this.querySelectorAll('button[type="button"]').forEach((btn) =>
      btn.addEventListener("click", this.close.bind(this)),
    );

    this.querySelectorAll("a[href]").forEach((link) =>
      link.addEventListener("click", this.close.bind(this)),
    );

    window.addEventListener("pageshow", (e) => {
      if (e.persisted) this.close();
    });

    if (this.backdrop) {
      this.backdrop.addEventListener("click", this.close.bind(this));
    }

    const cartIconLink = document.getElementById("cart-icon-bubble");
    if (cartIconLink) {
      cartIconLink.addEventListener("click", () => {
        if (this.classList.contains("active")) this.close();
      });
    }

    this._hovered = false;
    this.notification.addEventListener("pointerenter", (e) => {
      if (e.pointerType === "mouse") this._hovered = true;
    });
    this.notification.addEventListener("pointerleave", (e) => {
      if (e.pointerType === "mouse") this._hovered = false;
    });

  }

  _isHovered() {
    return this._hovered;
  }

  _scheduleAutoClose(ms) {
    if (this._autoCloseTimer) clearTimeout(this._autoCloseTimer);
    this._autoCloseTimer = setTimeout(() => {
      this._autoCloseTimer = null;
      if (this._isHovered()) {
        this._scheduleAutoClose(1000);
        return;
      }
      this.close();
    }, ms);
  }

  open() {
    if (this._autoCloseTimer) clearTimeout(this._autoCloseTimer);

    this.classList.add("active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true },
    );

    this._scheduleAutoClose(5000);
  }

  close() {
    if (this._autoCloseTimer) {
      clearTimeout(this._autoCloseTimer);
      this._autoCloseTimer = null;
    }

    this.classList.remove("active");
    this._hovered = false;

    const activeElement = document.activeElement;
    removeTrapFocus();
    if (activeElement && this.notification.contains(activeElement)) {
      activeElement?.blur();
    }
  }

  renderContents(parsedState) {
    this.cartItemKey =
      parsedState.key ||
      (parsedState.items && parsedState.items.length && parsedState.items[0].key) ||
      undefined;

    const isCartPage = window.location.pathname.includes("/cart");

    if (isCartPage) {
      this.clearCartPageEmptyState();
    }

    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (!el) return;
      const sectionKey = section.section || section.id;
      const html = parsedState.sections && parsedState.sections[sectionKey];
      if (!html) return;

      if (isCartPage) {
        const target = (section.selector && el.querySelector(section.selector)) || el;
        target.innerHTML = this.getSectionInnerHTML(html, section.selector);
      } else {
        el.innerHTML = this.getSectionInnerHTML(html, section.selector);
      }
    });

    if (isCartPage) return;

    // Allow the PDP inline quantity selector to override the notification heading
    if (typeof window.__pdpInlineHeadingOverride === "string" && window.__pdpInlineHeadingOverride) {
      const headingEl = this.notification?.querySelector(".cart-notification__heading");
      if (headingEl) headingEl.textContent = window.__pdpInlineHeadingOverride;
    }
    window.__pdpInlineHeadingOverride = null;

    if (this.header) this.header.reveal();
    this.open();
  }

  clearCartPageEmptyState() {
    document.querySelector("cart-items.cart-page")?.classList.remove("is-empty");
    document.getElementById("main-cart-footer")?.classList.remove("is-empty");
    document.getElementById("cart-page-milestone-progress")?.classList.remove("is-empty");
  }

  getSectionsToRender() {
    const isCartPage = window.location.pathname.includes("/cart");

    if (isCartPage) {
      return [
        {
          id: "cart-page-milestone-progress",
          section: document.getElementById("cart-page-milestone-progress")?.dataset.id,
          selector: ".progress-section",
        },
        {
          id: "cart-samples-gifts-tabs",
          section: document.getElementById("cart-samples-gifts-tabs")?.dataset.id,
          selector: ".js-contents",
        },
        {
          id: "main-cart-items",
          section: document.getElementById("main-cart-items")?.dataset.id,
          selector: ".js-contents",
        },
        {
          id: "main-cart-footer",
          section: document.getElementById("main-cart-footer")?.dataset.id,
          selector: ".cart__footer",
        },
      ].filter((s) => s.section);
    }

    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const node = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    return node ? node.innerHTML : "";
  }
}

customElements.define("cart-notification", CartNotification);
